import dayjs from 'dayjs'
import { AiFillEye } from 'react-icons/ai'
import { useTranslation } from 'react-i18next'
import { isEmpty } from 'lodash'
import helper from '../../utils/helpers'

const MarketingList = ({
  subAdmin,
  handelEdit,
  handleUserView,
  allSubAdmin,
  page,
  sort,
  setSort,
  paginationObj,
  manager
}) => {
  const { t } = useTranslation()
  const downloadFile = link => {
    helper.downloadFile(link)
  }

  return (
    <div className='p-3'>
      <div className='overflow-x-auto relative 
 border'>
        <table className='w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 '>
          <thead className='text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400'>
            <tr>
              <th scope='col' className='py-3 px-6'>
                #
              </th>

              <th scope='col' className='py-3 px-6 cursor-pointer'>
                <div className='flex'>
                  <span>{t('O_SUBJECT_LINE')} </span>
                </div>
              </th>

              <th scope='col' className='py-3 px-6 cursor-pointer'>
                <div className='flex'>
                  <span>{t('O_PDF')} </span>
                </div>
              </th>
              <th scope='col' className='py-3 px-6'>
                {t('O_SEND_TO')}
              </th>

              <th scope='col' className='py-3 px-6 cursor-pointer text-right'>
                <div className='flex justify-end'>
                  <span>{t('O_CREATED_AT')} </span>
                </div>
              </th>

              <th scope='col' className='py-3 px-6 text-center'>
                {t('O_ACTION')}
              </th>
            </tr>
          </thead>
          <tbody>
            {subAdmin &&
              subAdmin?.map((item, i) => (
                <tr
                  key={i}
                  className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'
                >
                  <th
                    scope='row'
                    className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'
                  >
                    {i + 1 + 10 * (paginationObj?.page - 1)}
                  </th>
                  <td className='py-2 px-2 border-r'>{item?.subjectLine}</td>
                  <td className='py-2 px-2 border-r'>
                    {item?.file ? (
                      <p
                        style={{ cursor: 'pointer' }}
                        onClick={() => downloadFile(item?.file)}
                      >
                        View
                      </p>
                    ) : (
                      'N/A'
                    )}
                  </td>
                  <td className='py-2 px-2 border-r'>{item?.sendTo}</td>
                  <td className='py-2 px-2 border-r text-right'>
                    {dayjs(item?.createdAt).format('DD-MM-YYYY hh:mm A')}
                  </td>

                  <td className='py-4 px-6 border-l'>
                    <div className=''>
                      <ul className='flex justify-center'>
                        <li
                          onClick={() => handleUserView(item)}
                          className='px-2 py-2 hover:bg-white hover:text-LightBlue'
                        >
                          <button title={t('O_VIEW')}>
                            {' '}
                            <AiFillEye className='w-5 h-5 text-slate-600' />{' '}
                          </button>
                        </li>
                      </ul>
                    </div>
                  </td>
                </tr>
              ))}
            {isEmpty(subAdmin) && (
              <tr className='bg-white border-b w-full text-center dark:bg-gray-800 dark:border-gray-700'>
                <td className='py-4 px-6' colSpan={12}>
                  {t('O_NO_RECORD_FOUND')}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default MarketingList
